import { useState, useEffect } from 'react';
import FAQNavbar from './components/FAQNavbar';
import FAQContent from './components/FAQContent';

export default function FAQPage() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <FAQNavbar isScrolled={isScrolled} />
      <FAQContent />
    </div>
  );
}
